// Styles
import { paletas } from "../../styles/theme";
import { Wrapper } from "./styles";

type Props = {
  tipo: string;
  frase: string;
};

export default function Mensagem({ tipo, frase }: Props) {
  const tema = () => {
    if (tipo === "sucesso") return paletas.GreenMunsell;
    if (tipo === "erro") return paletas.RedTheme;
    return paletas.White;
  };
  return <Wrapper cor={tema()}>{frase}</Wrapper>;
}
